import React, { useEffect, useState } from 'react';
import {
  Card,
  Text,
  Bubble,
  Row,
  Col,
  Tabs,
  Justify,
  TabPanel,
  Segment,
} from 'tea-component';

import SvgIcon from '@/pages/home/components/SvgIcon';
import './index.scss';
import Abnormal from '../Abnormal';
import { SegmentOption } from 'tea-component/lib/segment/SegmentOption';
import { useIntl } from 'umi';

interface ICardBoxInterFace {
  titleCom?: string | React.ReactNode;
  subTitleCom?: string | React.ReactNode;
  middleContentCom?: string | React.ReactNode;
  renderList: Array<any>;
  downloadClick?: () => any;
  className?: string;
  style?: any;
  isLoading: boolean;
  isNodata: boolean;
  isError: boolean;
  height?: any;
  bordered?: any;
  filterSlot?: React.ReactNode;
  defaultAvtive?: any;
  setCurrentDataType?: (svgType: string) => any;
  // 切换图类型触发
  onChangeChartType?: (tab: string) => void;
  segmentOption?: SegmentOption[];
  selectedSegment?: string;
  setSelectedSegment?: (value: string) => void;
  changeData?: (key: string, value: string | boolean | number) => any;
  dataKey?: string;
  failedMsg?: string;
  extraOperationSlot?: React.ReactNode;
  /** extraOperationSlot 是否放到操作区最右侧（默认 false，保持原有靠左顺序） */
  extraOperationAtEnd?: boolean;
  /** 有 segment 时，是否将操作图标放到标题行（默认 false，图标在 segment 下方） */
  operationInTitle?: boolean;
}

const defaultSvgTypeList = [
  {
    type: 'barChart',
    svgType: 'column-chart',
    content: 'Bar Chart',
  },
  {
    type: 'lineChart',
    svgType: 'discount-chart',
    content: 'Line Chart',
  },
  {
    type: 'sheet',
    svgType: 'sheet',
    content: 'Table',
  },
];

export default function TableLine(props: ICardBoxInterFace) {
  const { formatMessage } = useIntl();
  const {
    titleCom = <></>,
    subTitleCom,
    className = '',
    style = {},
    bordered = false,
    isLoading,
    isError,
    middleContentCom,
    isNodata,
    renderList,
    height,
    defaultAvtive = 0,
    filterSlot = null,
    setCurrentDataType,
    downloadClick,
    onChangeChartType,
    segmentOption,
    selectedSegment,
    setSelectedSegment,
    changeData,
    dataKey,
    failedMsg = formatMessage({ id: 'common_loading_failed' }),
    extraOperationSlot,
    extraOperationAtEnd = false,
    operationInTitle = false,
  } = props;

  const [activeChart, setActiveChart] = useState(
    renderList?.[defaultAvtive]?.type,
  );
  const [activeSvgType, setActiveSvgType] = useState(
    renderList?.[defaultAvtive]?.svgType,
  );
  let svgTypeList =
    renderList?.map((item) => ({
      type: item?.type,
      svgType: item?.svgType,
      content: item?.content,
      isHideCom: item?.isHideCom,
      isHideIcon: item?.isHideIcon
    })) || defaultSvgTypeList;
  if (activeSvgType === 'sheet')
    svgTypeList = svgTypeList?.filter((item) => item?.type !== 'eyes');

  const download = () => {
    downloadClick?.();
  };

  useEffect(() => {
    setCurrentDataType?.(renderList?.[defaultAvtive]?.type);
  }, []);

  return (
    <>
      <Card
        bordered={bordered}
        className={`basic-cardbox table-line ${className}`}
        style={style}
      >
        <Card.Body
          className="basic-cardbox-body"
          title={
            <>
              {titleCom && (
                <div className="basic-cardbox-title table-title">
                  {titleCom}
                </div>
              )}
              {subTitleCom && <>{subTitleCom}</>}
            </>
          }
          operation={(!segmentOption || operationInTitle) ? (
            <div className="operation-group">
              {!extraOperationAtEnd && extraOperationSlot}

              {!isNodata &&
                svgTypeList?.map((t) =>
                  !t?.isHideIcon && (
                    <Bubble
                      dark
                      placement="top"
                      content={t?.content || ''}
                      key={t.svgType}
                    >
                      <Text
                        className="table-btn table-line-show"
                        onClick={() => {
                          setCurrentDataType?.(t?.type);
                          if (t?.isHideCom) return;
                          setActiveChart(t?.type);
                          setActiveSvgType(t?.svgType);
                          onChangeChartType?.(t?.type);
                        }}
                      >
                        <SvgIcon
                          className={
                            activeSvgType !== t?.svgType
                              ? 'table-icon'
                              : 'action-icon'
                          }
                          type={t.svgType}
                        />
                      </Text>
                    </Bubble>
                  )
                )}

              {!isNodata && downloadClick && (
                <Text className="table-btn" onClick={download}>
                  <SvgIcon className={'table-icon'} type="download" />
                </Text>
              )}

              {extraOperationAtEnd && extraOperationSlot}
            </div>
          ) : null}
        >
          {segmentOption && (
            <>
              <Segment
                options={segmentOption}
                className={segmentOption.length ? '' : 'segment-empty'}
                value={selectedSegment}
                onChange={(value) => {
                  setSelectedSegment?.(value);
                  changeData?.(dataKey as string, value);
                }}
              />
              {!operationInTitle && (
                <div
                  className="operation-container"
                  style={{ textAlign: 'right' }}
                >
                  {!isNodata &&
                    svgTypeList?.map(
                      (t) =>
                        !t?.isHideIcon && (
                          <Bubble
                            dark
                            placement="top"
                            content={t?.content || ''}
                            key={t.svgType}
                          >
                            <Text
                              className="table-btn table-line-show"
                              onClick={() => {
                                setCurrentDataType?.(t?.type);
                                if (t?.isHideCom) return;
                                setActiveChart(t?.type);
                                setActiveSvgType(t?.svgType);
                                onChangeChartType?.(t?.type);
                              }}
                            >
                              <SvgIcon
                                className={
                                  activeSvgType !== t?.svgType
                                    ? 'table-icon'
                                    : 'action-icon'
                                }
                                type={t.svgType}
                              />
                            </Text>
                          </Bubble>
                        ),
                    )}
                  {!isNodata && downloadClick && (
                    <Text className="table-btn" onClick={download}>
                      <SvgIcon className={'table-icon'} type="download" />
                    </Text>
                  )}
                  {extraOperationAtEnd && extraOperationSlot}
                </div>
              )}
            </>
          )}
          {filterSlot !== null && <Justify left={<div>{filterSlot}</div>} />}
          {middleContentCom && <>{middleContentCom}</>}
          <Tabs activeId={activeChart} tabs={renderList}>
            {renderList?.map((item, index) => (
              <TabPanel id={item.type} key={index}>
                <Row>
                  <Col span={24} className="basic-cardbox-component-box">
                    <Abnormal
                      style={{ height: height ? height : 400 }}
                      component={item?.component}
                      isLoading={isLoading}
                      isError={isError}
                      isNoData={isNodata}
                      failedMsg={failedMsg}
                    />
                  </Col>
                </Row>
              </TabPanel>
            ))}
          </Tabs>
        </Card.Body>
      </Card>
    </>
  );
}
